import styled from '@emotion/styled';
import { color, typography } from '@uniquegood/realworld-studio-design';

interface TrialPageHeaderProps {
  planName: string;
  useMonths: number;
  userName?: string;
}

const TrialPageHeader = ({ planName, useMonths, userName }: TrialPageHeaderProps) => {
  return (
    <Container>
      <Title>{planName} 요금제 무료 체험</Title>
      <Subtitle>
        {userName ? `${userName}님이` : '당신이'} 소유자로 있는 채널에 {planName} 요금제를 {useMonths}
        개월 무료로 체험할 수 있어요.
      </Subtitle>
    </Container>
  );
};

export default TrialPageHeader;

const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 16px;
  padding: 8px 0;
  text-align: center;
`;

const Title = styled.h1`
  font-size: 28px;
  line-height: 32px;
  font-weight: ${typography.weight.bold};
  color: ${color.text_default};
  margin: 0;
`;

const Subtitle = styled.p`
  font-size: 14px;
  line-height: 20px;
  font-weight: ${typography.weight.regular};
  color: #8f8f8f;
  margin: 0;
`;
